import React from 'react'

import * as FaIcons from 'react-icons/fa'
import { Link } from 'react-router-dom';

import logo from '../images/crodudes_logo_1.png'
import groupcrocs from '../images/crodudes_group.png'
import metamask from '../images/metamask.png'
import WallletConnect from '../images/WalletConnect.png'

import { displayPopUp, closePopup, setGlobalState, getGlobalState, useGlobalState } from '../js/Main'
import { CroCoDudeContractABI, CroCoDudeContract } from '../js/contracts'

import Web3 from 'web3'
import WalletConnectProvider from '@walletconnect/web3-provider'




export const toggleMenu = () => {
    document.querySelector(".sidebar").classList.toggle("active");
}


const MMconnect = async() =>{
        closePopup(".connect-wallet-popup");
        alertPopup("Connecting..", "green", 10000);
        try{
            window.ethereum.request({method: 'eth_requestAccounts'})
            .then( async result => {
                try{
                const web3 = new Web3(window.ethereum);
                const contract =  new web3.eth.Contract(CroCoDudeContractABI, CroCoDudeContract);
                const price = await contract.methods.getMintPrice().call();
                var reflection = await contract.methods.getReflectionBalances().call({ from: result[0] })
                reflection = web3.utils.fromWei(reflection);
                setGlobalState('reflection', reflection);
                setGlobalState("mode", 1);
                setGlobalState('connectedAccount', result[0]);
                alertPopup("Connected!!", "green", 2500);
                }catch{
                    alertPopup("Please switch to BSC TESTNET!!", "red", 3500);
                    try {
                        await window.ethereum.request({
                        method: 'wallet_switchEthereumChain',
                        params: [{ chainId: '0x61' }], 
                        });
                        MMconnect();
                    } catch (error) {
                        if (error.code === 4902) {
                        try {
                            await window.ethereum.request({
                            method: 'wallet_addEthereumChain',
                            params: [
                                {
                                chainId: '0x61',
                                rpcUrl: 'https://data-seed-prebsc-1-s1.binance.org:8545/',
                                },
                            ],
                            });
                        } catch (addError) {
                            console.error(addError);
                        }
                        }
                        console.error(error);
                    }
                }
            })
        }catch{
            alertPopup("Please make sure MetaMask is installed or use WalletConnect!!", "red", 3000);
        }
         
  }
  const WCconnect = async() =>{
    var provider = new WalletConnectProvider({
      rpc: {
        97: "https://data-seed-prebsc-1-s1.binance.org:8545",
      }
    });
    try{
      await provider.enable();
      const web3 = new Web3(provider);
      const contract =  new web3.eth.Contract(CroCoDudeContractABI, CroCoDudeContract);
      window.w3 = web3;
      web3.eth.getAccounts()
      .then( async (result) => {
        closePopup(".connect-wallet-popup");
        var reflection = await contract.methods.getReflectionBalances().call({ from: result[0] })
        reflection = web3.utils.fromWei(reflection);
        setGlobalState('reflection', reflection);
        setGlobalState("mode", 2);
        alertPopup("Connected!!", "green", 2500);
        setGlobalState('connectedAccount', result[0]);
      })
    }catch{
        alertPopup("Error!", "red", 2500)
    }
    
  }

  export const alertPopup = (text, color, delay) =>{
    document.querySelector(".popupData").textContent = text;
    document.querySelector(".popupData").style.color = color;
    document.querySelector(".customPopup").style.top = "10px";
    setTimeout(() => {
        document.querySelector(".popupData").textContent = "";
        document.querySelector(".customPopup").style.top = "-100%";
    }, delay)
  }

  


const Home = () => {
    var account = useGlobalState('connectedAccount')[0];
    const mode = useGlobalState("mode")[0];
    var nfts = useGlobalState('nfts')[0], count=1;
    if(nfts.length > 0 ){
        if(nfts[0].edition === 1){
            nfts.reverse();
        }
    }
    const Mint = async () => {
        var web3;
        if(mode === 1){
            web3 = new Web3(window.ethereum);
        }else if(mode === 2){
            var provider = new WalletConnectProvider({
                    rpc: {
                    97: "https://data-seed-prebsc-1-s1.binance.org:8545",
                    }
                });
            await provider.enable();
            web3 = new Web3(provider);  
        }
        const contract =  new web3.eth.Contract(CroCoDudeContractABI, CroCoDudeContract);
        document.querySelector(".mint-details").textContent = "Pending";
        const price = await contract.methods.getMintPrice().call();
        const quantity = document.querySelector("#mint-quantity").value;
        if(quantity == 1){
            try{
                document.querySelector(".mint-details").textContent = "Processing";
                console.log(account);
                await contract.methods.mint().send({ from: account, value: price });
                document.querySelector(".mint-details").textContent = "Successful";
                setTimeout(() => {
                    document.querySelector(".mint-details").textContent = "";
                    closePopup(".mint-popup");
                }, 2000)
            }catch{
                document.querySelector(".mint-details").textContent = "Error";
                setTimeout(() => {
                    document.querySelector(".mint-details").textContent = "";
                }, 4000)
            }
        }else if(quantity > 1){
            document.querySelector(".mint-details").textContent = "Processing";
            try{
                await contract.methods.mintMany(quantity).send({ from: account, value: price*quantity });
                document.querySelector(".mint-details").textContent = "Successful";
                setTimeout(() => {
                    document.querySelector(".mint-details").textContent = "";
                    closePopup(".mint-popup");
                }, 2000)
            }catch{
                document.querySelector(".mint-details").textContent = "Error";
                setTimeout(() => {
                    document.querySelector(".mint-details").textContent = "";
                }, 4000)
            }
        }else{
            alertPopup("Enter a valid quantity", "red", 1500);
            document.querySelector(".mint-details").textContent = "";
        }
    }
    return (
        <>
            <header className="row">
                <div className="row logo">
                    <div className="logo-box">
                    <img src={ logo } alt="" />
                    </div>
                    <div>
                        CroCodudes
                    </div>
                </div>
                <div className="toggle" onClick={ toggleMenu }>
                    
                </div>
                <div className="sidebar row">
                    <ul className="row">
                        <li onClick={toggleMenu} style={{color: '86A656'}}><Link to="/">Home</Link></li>
                        <li onClick={toggleMenu}><Link to="/minted">Minted</Link></li>
                        <li onClick={toggleMenu}><Link to="/dashboard">Dashboard</Link></li>
                        <li onClick={toggleMenu}><Link to="/about">About us</Link></li>
                        <li><FaIcons.FaWallet /></li>
                    </ul>
                </div>
            </header>

            <div className='customPopup'>
                <div className='popupData'>
                    
                </div>
            </div>
            
            
            <div className=' row connect-wallet-popup'>
                <div className='column c-w-wrapper'>
                    <div style={{color: 'red', textAlign: 'right', fontSize: '30px', cursor: 'pointer'}} onClick={() => closePopup(".connect-wallet-popup")}>
                        <FaIcons.FaTimes />
                    </div>
                    <div className='row connect-btns'>
                        <div className='MMconnect row' onClick={MMconnect}>
                            <img src={metamask} alt=''/>
                        </div>
                        <div className='WCconnect row' onClick={WCconnect}>
                            <img src={WallletConnect} alt=''/>
                        </div>
                    </div>
                    
                </div>
            </div>


            <div className='row mint-popup'>
                <div className='column c-w-wrapper'>
                    <div style={{color: 'red', textAlign: 'right', fontSize: '30px', cursor: 'pointer'}} onClick={() => closePopup('.mint-popup')}>
                        <FaIcons.FaTimes />
                    </div>
                    <div className='column mint-sec minting-sec'>
                    <div style={{color:'red', fontSize: '14px', fontWeight: '900'}} className="mint-details"></div>
                    <select id='mint-quantity'>
                        <option defaultValue>Quantity</option>
                        <option>1</option>
                        <option>2</option>
                        <option>3</option>
                        <option>4</option>
                        <option>5</option>
                        <option>6</option>
                        <option>7</option>
                        <option>8</option>
                        <option>9</option>
                        <option>10</option>
                    </select>
                    <button onClick={Mint} className='btn'>Mint</button>
                    </div>
                    
                </div>
            </div>
            
            
            <main>
                <section className="row section-1">
                    <div className="column section-1-texts">
                        <h2>
                            A Fast  Evolving NFT <b className="main-color-text">Minting</b> Platform
                        </h2>
                        <p>
                            Welcome to the Swamp, Home of <b className="main-color-text">CroCoDudes.</b> An AutoStaking, Passive income generating NFT Project on the Cronos Chain. 
                        </p>
                        <div className="row">
                            <div className="btn-type-1" onClick={!account ? () => displayPopUp(".connect-wallet-popup") : () => alertPopup('Connected!', 'green', 2000)}>{!account ? 'Connect Wallet' : 'Connected'}</div>
                            <div className="btn-type-2"><Link to="/about">Learn More</Link></div>
                        </div>
                        <div className="row section-1-stats">
                            <div>10K<br /><small>Minted</small></div>
                            <div>500 CRO<br /><small>Total Earnings</small></div>
                            <div>1K+<br /><small>Holders</small></div>
                        </div>
                    </div>
                    <div className="column">
                        <div className="column section-1-box">
                                <div>
                                    <img src={ groupcrocs } alt="" />
                                </div>
                                <div>
                                    <h3>CroCodudes</h3>
                                    <p>An international abstract presentation, built for the community</p>
                                </div>
                                <div className="row">
                                    <div className="btn-type-2"  onClick={account ? () => displayPopUp(".mint-popup") : () => displayPopUp(".connect-wallet-popup")}>Mint</div>
                                    <div className="btn-type-2"><Link to="/minted">Explore</Link></div>
                                </div>
                        </div>
                        <div className="section-1-support">
                            <p>Supported By</p>
                            <div className="row">
                                <div>Coinbase</div>
                                <div>Binance</div>
                                <div>Ethereum</div>
                            </div>
                        </div>
                    </div>
                </section>


                <section className="column section-2">
                    <h1>Recent Mints</h1>
                    {nfts.length == 0 ? 
                        <div className='spinner'>
                            <div></div>
                        </div> 
                        : () => {}
                    }
                    <div className="row boxes">
                        {nfts.slice(0,6).map((nft) => (
                            <div className="column box" key={ nft.edition }>
                               <div>{ nft.name }</div>
                               <div className="box-img">
                                   <img src={ nft.image } alt="" />
                               </div>
                               <div className="row">
                                   Minted By: { nft.owner.slice(0,6) }......
                               </div>
                           </div>
                           ))}
                        
                    </div>
                </section>
            </main>
            <br />
            <hr />
            <br />
            <footer className="row footer">
                <div className="column footer-1">
                    <div className="row logo">
                        <div className="logo-box">
                            <img src={ logo } alt="" />
                        </div>
                        <div>
                            CroCoDudes
                        </div>
                    </div>
                    <div>
                        An international abstract presentation, built for the community
                    </div>
                    <br /><br />
                    <small>Copyright &copy; 2022 CroCoDudes. All Rights Reserved</small>
                </div>
                <div className="column footer-2">
                    <h1>Stay Connected</h1>
                    <div className="row footer-socials">
                        <div>
                            <a href='#'><FaIcons.FaTwitter/></a>
                        </div>
                        <div>
                            <a href='#'><FaIcons.FaTelegram/></a>
                        </div>
                        <div>
                            <a href='#'><FaIcons.FaDiscord/></a>
                        </div>
                        <div>
                            <a href='#'><FaIcons.FaMedium/></a>
                        </div>
                        <div>
                            <a href='#'><FaIcons.FaFacebook/></a>
                        </div>
                        <div>
                            <a href='#'><FaIcons.FaWhatsapp/></a>
                        </div>
                    </div>
                    <br /><br />
                    <small>Terms & Conditions / Privacy Policy</small>
                </div>
            </footer>
        </>
    )
}

export default Home
